import React, { useState } from "react";
import "../../../assets/css/admin/adminSettings/AdminSettings.css";
import AdminLayout from "../../../layouts/admin/adminlayout/AdminLayout";

const Settings = () => {
  const [activeTab, setActiveTab] = useState("profile");
  const [inAppNotifications, setInAppNotifications] = useState(true);
  const [emailNotifications, setEmailNotifications] = useState(false);

  return (
    <AdminLayout>
      <div className="settings-wrapper">
        {/* ❌ HEADER REMOVE - Kyunki AdminNavbar already hai */}
        {/* <div className="settings-header">... */}

        {/* TABS */}
        <div className="settings-tabs">
          <button
            className={`tab-btn ${activeTab === "profile" ? "active" : ""}`}
            onClick={() => setActiveTab("profile")}
          >
            👤 PROFILE SETTINGS
          </button>

          <button
            className={`tab-btn ${activeTab === "security" ? "active" : ""}`}
            onClick={() => setActiveTab("security")}
          >
            🔒 SECURITY
          </button>

          <button
            className={`tab-btn ${
              activeTab === "notifications" ? "active" : ""
            }`}
            onClick={() => setActiveTab("notifications")}
          >
            🔔 NOTIFICATION SETTINGS
          </button>
        </div>

        {/* CONTENT */}
        <div className="settings-main">
          <div className="settings-container">
            {/* PROFILE */}
            {activeTab === "profile" && (
              <div className="card">
                <div className="card-body">
                  <h2 className="section-title">Profile Settings</h2>

                  <div className="field-group">
                    <label>Full Name</label>
                    <input type="text" defaultValue="Admin User" />
                  </div>

                  <div className="field-group">
                    <label>Email Address</label>
                    <input type="email" defaultValue="admin@circlehub.com" />
                  </div>

                  <div className="field-group">
                    <label>Username</label>
                    <input type="text" defaultValue="adminuser" />
                  </div>

                  <button className="btn-primary">Save Changes</button>
                </div>
              </div>
            )}

            {/* SECURITY */}
            {activeTab === "security" && (
              <div className="card">
                <div className="card-body">
                  <h2 className="section-title">Security</h2>

                  <div className="field-group">
                    <label>Current Password</label>
                    <input type="password" />
                  </div>

                  <div className="field-group">
                    <label>New Password</label>
                    <input type="password" />
                  </div>

                  <div className="field-group">
                    <label>Confirm New Password</label>
                    <input type="password" />
                  </div>

                  <button className="btn-primary">Update Password</button>
                </div>
              </div>
            )}

            {/* NOTIFICATIONS */}
            {activeTab === "notifications" && (
              <div className="card">
                <div className="card-body">
                  <h2 className="section-title">Notification Settings</h2>

                  <div className="notification-row">
                    <div>
                      <h4>In-App Notifications</h4>
                      <p>Receive notifications inside the application</p>
                    </div>
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={inAppNotifications}
                        onChange={() =>
                          setInAppNotifications(!inAppNotifications)
                        }
                      />
                      <span className="slider"></span>
                    </label>
                  </div>

                  <div
                    className="notification-row"
                    style={{ borderBottom: "none" }}
                  >
                    <div>
                      <h4>Email Notifications</h4>
                      <p>Receive notifications via email</p>
                    </div>
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={emailNotifications}
                        onChange={() =>
                          setEmailNotifications(!emailNotifications)
                        }
                      />
                      <span className="slider"></span>
                    </label>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Settings;
